interface IStatus {
  size?: 'sm' | 'md' | 'lg';
  status?: boolean;
  variant?: 'primary' | 'danger' | 'warning';
}

export const Status = ({ size = 'md', status, variant = 'primary' }: IStatus) => {
  const color =
    status !== undefined
      ? status
        ? 'bg-primary'
        : 'bg-accent-red'
      : variant === 'primary'
      ? 'bg-primary'
      : variant === 'danger'
      ? 'bg-accent-red'
      : 'bg-accent-orange';

  const sizeClassNames = size === 'sm' ? 'h-2 w-2' : size === 'md' ? 'h-3 w-3' : 'h-5 w-5';

  return <span className={`rounded-full ${sizeClassNames} ${color}`} />;
};

Status.displayName = 'Status';
